import {React, useEffect, useState} from 'react';
import './CSS/HomePage.css';
import Hero from '../Components/Hero/Hero';
import Contact from '../Components/Contact/Contact';
import Services from '../Components/Services/Services';
import About from '../Components/About/About';
/*import Definitions from '../Components/Definitions/Definitions';*/

const Home = () => {
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);

  useEffect(()=>{window.scrollTo(0,0);},[]);

  return (
    <>
      {!isHeroLoaded && (
        <div className="loading-screen">
          <></>
        </div>
      )}
      <div className="home">
        <Hero onLoaded={() => setIsHeroLoaded(true)} />
        <About />
        {/*<Definitions />*/}
        <Services />
        <Contact />
      </div>
    </>
  );
};

export default Home;

